<div class="l-main__contents js-fit-contents">
  <app-breadcrumbs [label2]="title"></app-breadcrumbs>
  <h1 class="c-texts--head1">{{ title }}</h1>

  <div class="c-notification">
    <ul class="c-notification__list">
      <div *ngIf="petaboNotificationList.length === 0 && !loading">
        <div class="c-empty-state">
          <div class="empty-icon">📋</div>
          <p class="empty-message">現在お知らせはありません</p>
        </div>
      </div>

      <div *ngIf="petaboNotificationList.length > 0">
        <li
          *ngFor="let notification of petaboNotificationList"
          class="c-notification__item c-notification__item--neutral"
        >
          <a
            (click)="notificationLink(notification.profiles.url)"
            style="cursor: pointer"
            ActionTransaction
            [commandCd]="viewCd + '-clickPetabo-' + notification.id"
            ><span class="c-icon-hint"></span>
            <p>
              <small>{{ getDisplayDate(notification) | date : 'yyyy/MM/dd' }}</small>
            </p>
            <div style="margin: 0 1rem"></div>
            <p>{{ notification.name }}</p>
            <i class="c-icon__arrow_s_right"></i>
          </a>
        </li>
      </div>
    </ul>
  </div>
</div>
